'use client';

import { useQuery } from '@tanstack/react-query';

import { getClientSideURL } from '@/utilities/getURL';

export const queryForm = async (formId?: number) => {
  const result = await fetch(
    `${getClientSideURL()}/api/forms/${formId || 1}`,
  ).then((res) => res.json());

  return result || null;
};

export const useForm = (formId?: number) => {
  const query = useQuery({
    queryKey: ['form', formId],
    queryFn: () => queryForm(formId),
  });
  return query;
};
